module.exports = __webpack_public_path__ + "static/media/semiconductors_2_tablet.ef3a3d5d.jpg";